import { LOCAL_DATA_NAME, resolveNotificationType } from '@/helpers/enums';
import { getDeviceToken, isNotificationsSupported, onGetNotification } from './firebase/app';
import { getNotificationOptions } from './firebase/notification-utils';
import { preventedPagesFromNotification, notificationPageRedirect } from './notifications.config';

// an explicit redirectUrl/url always wins; otherwise fall back to the generic
// per-type destination (see notificationPageRedirect)
function resolveNotificationRedirect (data = {}) {
	return data.redirectUrl || data.url || notificationPageRedirect[resolveNotificationType(data.type)] || null;
}

function startNotification ({ router }, callBack = () => {}) {
	return getDeviceToken().then(token => {
		let fcmToken = null;
		if (token) {
			fcmToken = token;
			localStorage.setItem(LOCAL_DATA_NAME.FCM_DEVICE_TOKEN, token);

			// initializing on get notification (foreground)
			onGetNotification((payload) => {
				const currentRouteName = router.currentRoute.name;
				// data-only pushes (no `notification` block, e.g. silent state-change
				// notifications) must still reach callBack below, not just alert-style ones
				if (!preventedPagesFromNotification.includes(currentRouteName) && payload.notification) {
					const { title, body } = payload.notification;

					const notification =
						new Notification(title, getNotificationOptions(body));

					notification.onclick = () => {
						const redirectTarget = resolveNotificationRedirect(payload.data);
						if (redirectTarget) { router.push(redirectTarget).catch(() => {}); }
					};
				}
				if (typeof callBack === 'function') {
					callBack(payload);
				}
			})
		} else {
			throw new Error('No notification token generated')
		}
		return fcmToken;
	});
}

export {
	// default getting notification token function and starting notifications
	startNotification,

	// notifications basics to rebuild notification token function
	getDeviceToken,
	isNotificationsSupported,
	onGetNotification,
	getNotificationOptions
}
